/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconDroplet: {
  name: 'droplet';
  data: string;
} = {
  name: 'droplet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M315.394 48.206c-35.552 206.62-141.348 248.241-141.348 393.101 0 72.681 71.848 126.109 141.348 126.109 71.062 0 138.571-49.961 138.571-118.965 0-139.054-101.833-194.016-138.571-400.245zm-69.668 259.515h.002c-33.423 90.284-6.105 184.745 64.84 214.398 18.152 7.589 37.898 9.233 57.238 7.519-138.814 59.511-222.101-95.406-122.08-221.917z"/></svg>`,
};
